import clsx from 'clsx'

// One button shape for the whole product: a pill. Variants differ by fill,
// never by radius, so a primary CTA on the home page, the submit form and the
// admin panel are recognisably the same control.
const variantClasses = {
  // Brand action: forest-green fill.
  primary: 'bg-accent text-bg hover:bg-accent-ink active:bg-accent-ink disabled:opacity-50',
  // Headline action on a bare page (hero, final CTA): near-black fill.
  dark: 'bg-ink text-bg hover:bg-ink-2 active:bg-ink-2 disabled:opacity-50',
  secondary:
    'border border-line-strong bg-bg-elev text-ink hover:border-ink-2 hover:bg-bg-sunk disabled:text-muted',
  ghost: 'bg-transparent text-ink-2 hover:bg-bg-sunk hover:text-ink disabled:text-muted',
  danger: 'bg-danger text-bg hover:opacity-90 disabled:opacity-50',
  // Third tier, below secondary: reads as a link, not a button. For utility
  // actions sitting next to a real CTA (tours, "learn more", skip) that
  // shouldn't compete with it for the click.
  tertiary:
    'bg-transparent px-0 text-muted underline-offset-4 hover:text-ink hover:underline disabled:text-muted-2',
}

const sizeClasses = {
  sm: 'h-8 px-3.5 text-[13px]',
  md: 'h-10 px-4 text-sm',
  lg: 'h-12 px-6 text-[15px]',
}

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-[-0.01em] whitespace-nowrap select-none active:scale-[0.98] disabled:cursor-not-allowed disabled:active:scale-100'

/**
 * Class string for non-<button> elements (react-router <Link>, <a>) so a link
 * styled as a button is pixel-identical to <Button>.
 */
export default function buttonClasses({ variant = 'primary', size = 'md', className } = {}) {
  return clsx(
    BASE,
    variantClasses[variant] || variantClasses.primary,
    variant === 'tertiary' ? 'h-auto py-1 text-sm' : sizeClasses[size] || sizeClasses.md,
    className,
  )
}
